import { render } from "./range-slider.vue?vue&type=template&id=2b656ed0&scoped=true&ts=true"
import script from "./range-slider.vue?vue&type=script&lang=ts"
export * from "./range-slider.vue?vue&type=script&lang=ts"

import "./range-slider.vue?vue&type=style&index=0&id=2b656ed0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b656ed0"]])

export default __exports__